import { IUi } from './ui.interfaces';
import { UIActions, UIActionTypes } from './ui.actions';

export function uiInitialState(): IUi {
  return {
    isLoginCheckComplete: false,
    isLoggedIn: false,
    isApprover: false,
    isSearcher: false,
    isLot: null,
    lotUnits: [],
    strataPlanNumber: '',
    strataPlanNumberFriendlyName: '',
    subdomain: '',
    siteSettings: null,
    actionStatus: null,
  };
}

export function UiReducer(state = uiInitialState(), action: UIActions) {
  switch (action.type) {
    case UIActionTypes.SET_LOGIN_CHECK_COMPLETE:
      return {
        ...state,
        isLoginCheckComplete: true,
      };
    case UIActionTypes.SET_SUB_DOMAIN:
      return {
        ...state,
        subdomain: action.payload,
      };
    case UIActionTypes.SET_STRATA_PLAN_FRIENDLY_NAME:
      return {
        ...state,
        strataPlanNumberFriendlyName: action.payload,
      };
    case UIActionTypes.SET_IS_LOGGED_IN_FALSE:
      return {
        ...state,
        isLoggedIn: false,
        isApprover: false,
        isSearcher: false
      };
    case UIActionTypes.LOAD_ACTION_STATUS_SUCCESS:
      return {
        ...state,
        actionStatus: action.payload,
      };

    case UIActionTypes.SET_IS_LOGGED_IN_TRUE:
      return {
        ...state,
        isLoggedIn: true,
      };
    case UIActionTypes.FETCH_LOTS_AND_UNITS_SUCCESS:
      return {
        ...state,
        isLot: action.payload.isLot,
        strataPlanNumber: action.payload.strataPlanNumber,
        lotUnits: action.payload.lotUnits,
      };
    case UIActionTypes.APPROVER_USER_LOGIN:
      return {
        ...state,
        isApprover: true,
        isSearcher: false
      };
    case UIActionTypes.SEARCHER_USER_LOGIN:
      return {
        ...state,
        isSearcher: true,
        isApprover: false,
      };
    case UIActionTypes.FETCH_LOTS_AND_UNITS_WITH_STRATA_PLAN_SUCCESS:
      return {
        ...state,
        isLot: action.payload.isLot,
        strataPlanNumber: action.payload.strataPlanNumber,
        strataPlanNumberFriendlyName: action.payload.strataPlanNumberFriendlyName,
        lotUnits: action.payload.lotUnits,
      };

    case UIActionTypes.FETCH_SITE_SETTINGS_SUCCESS:
      return {
        ...state,
        siteSettings: action.payload
      };
    default:
      return state;
  }
}
